import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

export const useHostedIdvIframeMode = () => {
  const {
    flags: { mangopayHostedIdvIframe = false },
  } = useFeatureFlags();
  const { isMobileApp, isTwa } = useIsMobileApp();

  return mangopayHostedIdvIframe && !isMobileApp && !isTwa;
};
